export interface PEInventoryMetricsItem {
  date: string;
  resin_type?: string | null;
  days_of_inventory?: number | null;
  inventory_change?: number | null;
  inventory_change_monthly?: number | null;
  inventory_change_cumulative?: number | null;
  operating_rates?: number | null;
  demand_rates?: number | null;
  domestic_production?: number | null;
  domestic_demand?: number | null;
  total_sales?: number | null;
  exports?: number | null;
  export_rates?: number | null;
  capacity?: number | null;
}

export interface PEProductionCapacityItem {
  date: string;
  resin_type?: string | null;
  production?: number | null;
  capacity?: number | null;
  total_sales?: number | null;
}

export interface PEMarketsItem {
  date: string;
  resin_type?: string | null;
  blow_molding?: number | null;
  pipe_conduit?: number | null;
  injection_molding?: number | null;
  film?: number | null;
  liquid_food_bottles?: number | null;
  other_segments?: number | null;
  food_packaging_film?: number | null;
  extrusion_coating?: number | null;
  non_packaging_film?: number | null;
  all_other_non_food_packaging?: number | null;
  non_food_packaging_film?: number | null;
  shrink_stretch_film_total: number | null;
  packaging_film?: number | null;
  trash_and_can_liners?: number | null;
}

export interface PERatesItem {
  date: string;
  resin_type?: string | null;
  operating_rates?: number | null;
  demand_rates?: number | null;
  export_rates?: number | null;
}

export interface USITCTradeItem {
  country?: string | null;
  region?: string | null;
  volume_kg?: number | null;
  date?: string | null;
  trade_direction?: string | null;
}

export interface FeedstockForecastItem {
  date: string;
  wti_crude?: number | null;
  brent_crude?: number | null;
  nat_gas?: number | null;
  ethylene_spot?: number | null;
  propane?: number | null;
  ethane?: number | null;
}

export interface PECommentaryItem {
  date?: string | null;
  pe_inv_cum_gains_draws?: string | null;
  pe_prod_sales?: string | null;
  hdpe?: string | null;
  ldpe?: string | null;
  lldpe?: string | null;
}

export enum PEDashboardTab {
  PE_TOTALS = 'PE_TOTALS',
  HDPE = 'HDPE',
  LDPE = 'LDPE',
  LLDPE = 'LLDPE',
  INVENTORY_CHANGE = 'INVENTORY_CHANGE',
  DEMAND_PRODUCTION_CAPACITY = 'DEMAND_PRODUCTION_CAPACITY',
  FEEDSTOCKS = 'FEEDSTOCKS',
  USITC = 'USITC',
  MARKETS = 'MARKETS',
  RATES = 'RATES',
  FAIR_PRICE = 'FAIR_PRICE',
}

export enum PEMetricFilter {
  DAYS_INVENTORY = 'days_of_inventory',
  DEMAND_RATE = 'demand_rates',
  DOMESTIC_DEMAND = 'domestic_demand',
  DOMESTIC_PRODUCTION = 'domestic_production',
  EXPORTS = 'exports',
  INVENTORY_CHANGE = 'inventory_change',
  INVENTORY_CHANGE_CUMULATIVE = 'inventory_change_cumulative',
  OPERATING_RATES = 'operating_rates',
  TOTAL_SALES = 'total_sales',
}

export const PE_METRIC_LABELS: Record<PEMetricFilter, string> = {
  [PEMetricFilter.DAYS_INVENTORY]: 'Days of Inventory',
  [PEMetricFilter.DEMAND_RATE]: 'Demand Rate %',
  [PEMetricFilter.DOMESTIC_DEMAND]: 'Domestic Demand',
  [PEMetricFilter.DOMESTIC_PRODUCTION]: 'Domestic Production',
  [PEMetricFilter.EXPORTS]: 'Exports',
  [PEMetricFilter.INVENTORY_CHANGE]: 'Inventory Change',
  [PEMetricFilter.INVENTORY_CHANGE_CUMULATIVE]: 'Inventory Change (Cumulative)',
  [PEMetricFilter.OPERATING_RATES]: 'Operating Rates %',
  [PEMetricFilter.TOTAL_SALES]: 'Total Sales',
};
